/** *************************************************
 *
 * This file is loaded on the legacy site to allow
 * the new header and footer to work without
 * conflicting with our Drupal pages.
 *
 * Once we are no longer using the new header on the
 * legacy site, this file can be safely removed.
 *
 ************************************************** */

import { safeFocusInit as initializeSafeFocus } from '@sparkbox/safe-focus';
import { setBuildVersion } from './buildVersion';
import { configureButtonsForToggling } from './accordion';
import { toggleMenu } from './toggleMenuHelpers';
import { registerToggles } from './toggle';
import { initializeMainMenu } from './mainMenu';

(() => {
  initializeSafeFocus();
  setBuildVersion('BUILD_VERSION_HF');

  const hamburger = document.querySelector('#header-menu-button-wrapper');
  hamburger.classList.add('js-hamburger-trigger');

  initializeMainMenu();

  configureButtonsForToggling(
    document.querySelectorAll('.cmp-header__menu-button'),
    document.querySelectorAll('.cmp-header__content'),
  );

  // Fixes the page when menu is open
  toggleMenu(
    document.querySelectorAll('.cmp-header__menu-button'),
    document.querySelector('body'),
  );

  registerToggles();
})();
